import { loginRequest } from "../../authConfig";
import { msalInstance } from "../../index";
import { jscd } from "../../scripts/helperScripts";
import { reactDBWhoAmI, writeLoggedIn } from "../services/soar";

export async function callMsGraph(graphEndpoint, accessToken) {
  if (!accessToken) {
    const account = msalInstance.getActiveAccount();
    if (!account) {
      console.log(
        "No active account! Verify a user has been signed in and setActiveAccount has been called."
      );
      return;
    }

    const response = await msalInstance.acquireTokenSilent({
      ...loginRequest,
      account: account,
    });
    accessToken = response.accessToken;
  }

  const browserDetails = await jscd();

  const headers = new Headers();
  const bearer = `Bearer ${accessToken}`;

  headers.append("Authorization", bearer);

  const options = {
    method: "GET",
    headers: headers,
  };

  fetch(graphEndpoint, options)
    .then((response) => response.json())
    .then((response) => {
      //add some localstorage and who am i functionality
      let userState = {
        isAuthenticated: true,
        user: {
          displayName: response.displayName,
          givenName: response.givenName,
          surname: response.surname,
          azureId: response.id,
          email: response.mail,
          domainName: `safy\\${response.mail.split("@")[0]}`,
          businessPhones: response.businessPhones,
          mobilePhone: response.mobilePhone,
          jobTitle: response.jobTitle,
          officeLocation: response.officeLocation,
          safyInfo: "",
          divisions: "",
          modules: "",
          at: "",
        },
        error: null,
        authTimeout: false,
      };

      console.log("UserState", userState);
      reactDBWhoAmI(response.mail.split("@")[0], response.id).then((resp) => {
        console.log("WhoAmI response", { resp });
        let si = JSON.parse(resp).UserInfo.row[0];
        console.log("safyInfo", si);
        userState.user.safyInfo = si;
        let divisions = [];
        si.divisions.forEach((element) => {
          if (element.Active === "1") {
            divisions.push(element.DivisionName);
          }
        });
        divisions.sort();
        userState.user["divisions"] = divisions;
        let modules = [];
        si.modules.forEach((element) => {
          if (element.Active === "1") {
            modules.push(element.ModuleName);
          }
        });
        userState.user["modules"] = modules;
        localStorage.setItem("safyInfo", JSON.stringify(userState));
        const siteUrl =
          process.env.REACT_APP_ENVIRONMENT === "Production"
            ? "safyportal.safy.org"
            : "safyportaltest.safy.org";
        writeLoggedIn(
          userState.user.safyInfo.ADUser,
          userState.user.displayName,
          userState.user.azureId,
          userState.user.safyInfo.BusinessUnitIdName,
          siteUrl,
          JSON.stringify({
            "OS": `${browserDetails.os} ${browserDetails.osVersion}`,
            "Build": process.env.REACT_APP_BUILD,
            "Browser": `${browserDetails.browser} ${browserDetails.browserMajorVersion} (${browserDetails.browserVersion})`,
            "Mobile": browserDetails.mobile,
            "Cookies": browserDetails.cookies,
            "Screen Size": browserDetails.screen,
            "Full User Agent: ": window.navigator.userAgent,
          })
        );

        if (window.location.href.includes("/share/")) {
          window.location.replace(window.location.href.replace("/share", ""));
        }
      });
    })
    .catch((error) => console.log(error));
}

export async function getAvatar(accessToken) {
  if (!accessToken) {
    const account = msalInstance.getActiveAccount();
    if (!account) {
      //change to not throw error but just return
      //throw Error("No active account! Verify a user has been signed in and setActiveAccount has been called.");
      return;
    }

    const response = await msalInstance.acquireTokenSilent({
      ...loginRequest,
      account: account,
    });
    accessToken = response.accessToken;
  }

  const headers = new Headers();
  const bearer = `Bearer ${accessToken}`;

  headers.append("Authorization", bearer);

  const options = {
    method: "GET",
    headers: headers,
    responseType: "blob",
  };

  return (
    fetch("https://graph.microsoft.com/v1.0/me/photos/48x48/$value", options)
      // .then(response =>  "data:" + response.headers["content-type"] + ";base64," + response.body.toString('base64'))
      .then((response) => response.blob())
      .catch((error) => console.log(error))
  );
}
